import { ToggleButton } from '@mui/material'
import { styled } from '@mui/styles'

export const StyledToggleButton = styled(ToggleButton)({
  flex: 1,
  height: '32px',
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'none',
  border: 'none',
  color: 'content.secondary',
  backgroundColor: 'transparent',
  borderRadius: 0,
  zIndex: 1,
  position: 'relative',
  boxSizing: 'border-box',
  transition: 'color 0.2s',
  '&.Mui-selected': {
    color: 'primary.main',
    border: 'none',
    zIndex: 2,
    backgroundColor: 'transparent',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -2,
      left: -2,
      right: -2,
      bottom: -2,
      border: '2px solid #2570EB',
      borderRadius: '6px',
      pointerEvents: 'none',
      zIndex: 3,
    },
    '&:hover': {
      backgroundColor: 'rgba(37, 112, 235, 0.04)',
    }
  },
  '&:hover': {
    backgroundColor: 'rgba(37, 112, 235, 0.04)',
  }
})